/**
 * Registro público de feria (sin autenticación).
 */
import publicApi from "../api/publicApi";

/**
 * @param {{ nombre: string, email: string, telefono: string, whatsapp: string }} payload
 */
export const registrarFeria = (payload) =>
    publicApi.post("/public/feria/registros", payload);
